import React from "react"
import { useTranslation } from "react-i18next"

interface WidgetPartnersProps {
    partners: { url: string, imgSrc: string, imgAlt: string }[];
}

export const WidgetPartners: React.FC<WidgetPartnersProps> = ({ partners }) => {
    const { t } = useTranslation();
    return (
        <div className="widget">
            <div className="widget-title">
                <h4>{t('widgets.partners.title')}</h4>
            </div>
            <ul className="list-unstyled list-style mb-0">
                {partners.map(({ url, imgSrc, imgAlt }, index) => (
                    <li key={index} className="mb-2">
                        <a href={url} target="_blank" title={imgAlt}>
                            <img src={imgSrc} alt={imgAlt} className="w-100" />
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default WidgetPartners;